import { Store } from "vuex";
import { namespace as settingsNameSpace } from "../modules/settings/settings";
import { settingName, Language } from "@infoland/iprova-api";

export class SettingsStore {
    private store: Store<any>;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /**
     * gets value that has been get before (USE WITH CAUTION)
     */
    public get(name: settingName | string) {
        return this.store.state[settingsNameSpace][name];
    }

    /**
     * Gets the setting value based on a setting name (enum value)
     * @param name the setting name
     */
    public getSettingAsync<T>(name: settingName | string): Promise<T> {
        return this.store.dispatch(`${settingsNameSpace}/getSettingAsync`, name);
    }
}
